<template>
  <div class="client">
    <div class="client-box">
      <div class="client-content">
        <div class="client-content-left">
          <div class="client-content-one">便捷查询 \ 随时随地浏览信息</div>
          <div class="client-content-two">被征收户端</div>
          <div class="client-content-four" style=" margin-top: 30px;">为征收项目里的征收户提供所属项目动迁信息、个人补偿信</div>
          <div class="client-content-four">息、安置信息的查询</div>
          <div class="client-btn" @click="toLogin">点击登录</div>
        </div>
        <div class="client-content-right">
          <img src="../assets/img/beizhengshouhu_0011.png" />
        </div>
      </div>
    </div>
    <div class="client-content-box">
      <div class="client-one">
        <div class="client-one-left" id="wrapper-text">
          <div class="text-one">政策信息便捷查询</div>
          <div class="text-two">支持身份验证核实被征收人信息，快速查询项目补偿政策方案</div>
        </div>
        <div class="client-one-right" id="wrapper-img">
          <img src="../assets/img/beizhengshouhu_01.png" />
        </div>
      </div>
      <div class="client-two">
        <div class="client-one-left" id="wrapper-text1">
          <div class="text-one">随时随地浏览信息</div>
          <div class="text-two">依托手机微信平台载体，即时浏览个人基础信息及相关附件信息</div>
        </div>
        <div class="client-one-right" id="wrapper-img1">
          <img src="../assets/img/beizhengshouhu_02.png" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  mounted() {
    var x = document.getElementById('wrapper-img');
    x.setAttribute(
      'class',
      ' animate__animated animate__fadeInRight client-one-right'
    );
    var y = document.getElementById('wrapper-text');
    y.setAttribute(
      'class',
      ' animate__animated animate__fadeInLeft client-one-left'
    );
    var x1 = document.getElementById('wrapper-img1');
    x1.setAttribute(
      'class',
      ' animate__animated animate__fadeInRight client-one-right'
    );
    var y1 = document.getElementById('wrapper-text1');
    y1.setAttribute(
      'class',
      ' animate__animated animate__fadeInLeft client-one-left'
    );
  },
  methods: {
    toLogin() {
      window.open('https://yzh.yunzhengshou.com');
    }
  }
};
</script>
<style>
.client {
  width: 100%;
}
.client-box {
  display: flex;
  width: 100%;
  height: 650px;
  background: url('../assets/img/blue.png') no-repeat center;
  background-size: 100% 650px;
  overflow: hidden;
}
.client-content {
  display: flex;
  width: 1500px;
  height: 650px;
  margin: auto;
  overflow: hidden;
}
.client-content-left {
  margin-top: 70px;
  margin-left: 30px;
  width: 50%;
}
.client-content-one {
  font-family: '微软雅黑';
  font-weight: 400;
  font-style: normal;
  font-size: 24px;
  color: #ffffff;
}
.client-content-two {
  font-family: '微软雅黑 Bold', '微软雅黑';
  font-weight: 700;
  font-style: normal;
  font-size: 60px;
  color: #ffffff;
  margin-top: 34px;
}
.client-content-three {
  margin-top: 20px;
  font-family: '微软雅黑 Bold', '微软雅黑';
  font-weight: 700;
  font-style: normal;
  font-size: 72px;
  color: #ffffff;
}
.client-content-four {
  font-family: '微软雅黑';
  font-weight: 400;
  font-style: normal;
  font-size: 20px;
  color: #ffffff;
  line-height: 40px;
}
.client-btn {
  width: 110px;
  height: 40px;
  background-color: rgba(255, 255, 255, 1);
  border-radius: 10px;
  border: 1px solid rgba(0, 189, 183, 1);
  text-align: center;
  line-height: 40px;
  color: rgba(0, 189, 183, 1);
  cursor: pointer;
  margin-top: 42px;
}
.client-btn:hover {
  color: rgb(41, 146, 151);
}
.client-content-right {
  width: 50%;
}
.client-content-right img {
  width: 100%;
}
.client-content-box {
  width: 1500px;
  margin: auto;
  overflow: hidden;
}
.client-one,
.client-two,
.client-three {
  display: flex;
  padding: 50px 64px;
}
.text-one {
  font-family: '微软雅黑';
  font-weight: 410;
  font-style: normal;
  font-size: 48px;
  color: #495362;
}
.text-two {
  margin-top: 10px;
  font-family: '微软雅黑';
  font-weight: 400;
  font-style: normal;
  font-size: 28px;
  color: #495362;
  line-height: 50px;
}
.client-one-left {
  padding-right: 100px;
  width: 50%;
  margin-top: 100px;
}
.client-one-right {
  width: 50%;
}
.client-one-right img {
  width: 80%;
  height: 80%;
}
</style>
<style media="screen">
/*分辨率低于1280，采用下面的样式*/
@media screen and (max-device-width: 1500px) {
  .client-content,
  .client-content-box {
    width: 1200px !important;
  }
  .client-content-two {
    font-size: 36px !important;
  }
  .client-content-four {
    font-size: 16px !important;
  }
  .text-one {
    font-size: 36px !important;
  }
  .text-two {
    font-size: 20px !important;
  }
  .client-content-three {
    font-size: 48px !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/page/expropriated-client.vue